<div class="main-layout">
  <div class="main-layout__inner">
    <div class="main-layout__sidenav">
      <app-side-nav></app-side-nav>
    </div>
    <div class="main-layout__content">
      <app-header></app-header>
      <div class="main-layout__body">
        <div class="main-layout__page">
          <div class="main-layout__breadcrumb">
            <app-breadcrumb />
          </div>
          <router-outlet></router-outlet>
        </div>

        <div class="main-layout__footer">
          @if (isFuturesRoute()) {
            <app-futures-footer />
          } @else {
            <app-footer></app-footer>
          }
        </div>
      </div>
    </div>
  </div>
</div>

@if (globalLoaderState | async) {
  <div class="c-global-loader-wrapper">
    <app-loader />
  </div>
}
